<script>
	export let block;
	export let data;
	export let index;
	export let j;
	export let type = "";

	import { cloneDeep } from "lodash-es";
	import {
		isMobile,
		saved,
		changed,
		isNewDataChanged,
	} from "../../../../../stores/variables";

	let opened;

	$: if ($saved) {
		if ($saved === "saved") {
			opened = false;
			if (
				data[data.field_name] &&
				data[data.field_name][index] &&
				data[data.field_name][index].active
			) {
				$isNewDataChanged = true;
				block.newData[block.field_name] = block.value;
				data[data.field_name][index][j] = block;
				data.loadedData[index][block.field_name] = block.value;
				data.loadedData[index]["toUpdate"] = true;

				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.loadedData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp["ID"] == data.loadedData[index]["ID"])
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.loadedData[index]
						);
						check = false;
					}
				}
			}
			if (
				data[data.field_name + "_new"] &&
				data[data.field_name + "_new"][index] &&
				data[data.field_name + "_new"][index].active
			) {
				$isNewDataChanged = true;
				if (block.value) {
					block.newData[block.field_name] = block.value;
					data.createdData[index][block.field_name] = block.value;
				} else {
					block.newData[block.field_name] = "";
					data.createdData[index][block.field_name] = "";
				}
				data[data.field_name + "_new"][index][j] = block;
				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.createdData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp.temp_id == data.createdData[index].temp_id)
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.createdData[index]
						);
						check = false;
					}
				}
			}
		}
		if ($saved === "canceled") {
			opened = false;
			block.value = block.before.value;
		}
	}

	if (!block.newData) block.newData = [];
	if (!block.value) block.value = "";
	if (block.newData) {
		block.value = block.newData[block.field_name];
	}

	$: if (!opened) {
		opened = "1";
		if (!block.before) block.before = {};
		block.before.value = cloneDeep(block.value);
	}
	// let sw;
</script>

{#if block}
	<div class="modal__item-name">
		<span class="modal__item-name-text">{block.name ? block.name : ""}</span
		>
		<!-- <span class="modal__edit" on:click={() => (sw = !sw)}> -->
		<span class="modal__edit">
			<i class="fas fa-pen" />
		</span>
	</div>
	<!-- {#if sw} -->
	<textarea
		name=""
		id=""
		maxlength={block.maxlength ? block.maxlength : 10000}
		on:input={() => ($changed = true)}
		bind:value={block.value}
		class={$isMobile ? "mobile" : "not_mobile"}
	/>
	<!-- {:else}
		<div class="content {$isMobile ? 'mobile' : 'not_mobile'}">
			{@html block.value}
		</div>
	{/if} -->
{/if}

<style lang="scss">
	textarea {
		display: flex;
		width: 100%;
		font-size: 15px;
		padding: 18px 20px;
		color: var(--text-black-1);
		border: 0;
		outline: 0;
		resize: none;
		height: 150px;
		border-right: 1px solid #eaebf2;

		&.not_mobile::-webkit-scrollbar {
			width: 12px;
			height: 12px;
		}

		&::-webkit-scrollbar {
			width: 0px;
			height: 0px;

			&-track {
				background: var(--bg-main-1);
				box-shadow: 0 0 2px hsla(0, 0%, 0%, 0.2);
			}

			&-thumb {
				background: var(--color-1);
				border-radius: 8px;
				transition: background-color 0.2s ease;
				border: 3px solid var(--bg-main-1);
			}
		}
	}

	// .content {
	// 	display: flex;
	// 	width: 100%;
	// 	font-size: 15px;
	// 	padding: 18px 20px;
	// 	color: var(--text-black);
	// 	height: 150px;
	// 	border-right: 1px solid #eaebf2;
	// 	overflow: auto;

	// 	&.not_mobile::-webkit-scrollbar {
	// 		width: 12px;
	// 		height: 12px;
	// 	}

	// 	&::-webkit-scrollbar {
	// 		width: 0px;
	// 		height: 0px;

	// 		&-track {
	// 			background: var(--bg-main);
	// 			box-shadow: 0 0 2px hsla(0, 0%, 0%, 0.2);
	// 		}

	// 		&-thumb {
	// 			background: var(--color-1);
	// 			border-radius: 8px;
	// 			transition: background-color 0.2s ease;
	// 			border: 3px solid var(--bg-main);
	// 		}
	// 	}
	// }
</style>
